import request from '../request';

const sellerDiscountSettingService = {
  getAll: (params) =>
    request.get('dashboard/seller/discount-settings/paginate', { params }),
  selectPaginate: (params) =>
    request.get('dashboard/seller/discount-settings/select-paginate', {
      params,
    }),
  getById: (id, params) =>
    request.get(`dashboard/seller/discount-settings/${id}`, { params }),
  create: (params) =>
    request.post('dashboard/seller/discount-settings', {}, { params }),
  update: (id, params) =>
    request.put(`dashboard/seller/discount-settings/${id}`, {}, { params }),
  delete: (params) =>
    request.delete('dashboard/seller/discount-settings/delete', { params }),
  search: (params) =>
    request.get('dashboard/seller/discount-settings/search', { params }),
};

export default sellerDiscountSettingService;